import { createNamedAction } from 'helpers/ActionUtil'
import {
  CHANGE_VALUE_SUCCESS,
  CHANGE_RESOLUTION_VALUE,
  UPDATE_RESOLUTION_VALUE,
  CHANGE_SIZE_VALUE,
  UPDATE_SIZE_VALUE,
  CHANGE_VENDOR_VALUE,
  UPDATE_VENDOR_VALUE,
  CHANGE_PART_NUMBER_VALUE,
  UPDATE_PART_NUMBER_VALUE,
  UPDATE_REFRESH_RATE_VALUE,
  CHANGE_REFRESH_RATE_VALUE,
  ADD_PANEL_START,
  ADD_PANEL,
  REMOVE_PANEL_START,
  REMOVE_PANEL,
} from './constants'

const changeValueSuccess = () => ({ type: CHANGE_VALUE_SUCCESS })

const changeRefreshRateValue = (index, panelRefreshRateId) => ({
  type: CHANGE_REFRESH_RATE_VALUE,
  index,
  panelRefreshRateId
})

const updateRefreshRateValue = (index, panelRefreshRateId, refreshRate) => ({
  type: UPDATE_REFRESH_RATE_VALUE,
  refreshRate,
  panelRefreshRateId,
  index
})

const changeResolutionValue = (index, panelResolutionId) => ({
  type: CHANGE_RESOLUTION_VALUE,
  index,
  panelResolutionId
})

const updateResolutionValue = (index, panelResolutionId, width, height) => ({
  type: UPDATE_RESOLUTION_VALUE,
  width,
  height,
  panelResolutionId,
  index
})

const changeSizeValue = (index, panelSizeId) => ({
  type: CHANGE_SIZE_VALUE,
  index,
  panelSizeId
})

const updateSizeValue = (index, panelSizeId, size) => ({
  type: UPDATE_SIZE_VALUE,
  panelSizeId,
  size,
  index
})

const changeVendorValue = (index, panelVendorId) => ({
  type: CHANGE_VENDOR_VALUE,
  index,
  panelVendorId
})

const updateVendorValue = (index, panelVendorId, vendorName) => ({
  type: UPDATE_VENDOR_VALUE,
  panelVendorId,
  vendorName,
  index
})

const changePartNumberValue = (index, partNumber) => ({
  type: CHANGE_PART_NUMBER_VALUE,
  partNumber,
  index
})

const updatePartNumberValue = (index, partNumber) => ({
  type: UPDATE_PART_NUMBER_VALUE,
  partNumber,
  index
})

const addPanel = () => ({ type: ADD_PANEL })
const removePanel = (index) => ({ type: REMOVE_PANEL, index })

const getActions = (path) => {
  return {
    changeRefreshRateValue: createNamedAction(path, changeRefreshRateValue),
    updateRefreshRateValue: createNamedAction(path, updateRefreshRateValue),
    changePartNumberValue: createNamedAction(path, changePartNumberValue),
    updatePartNumberValue: createNamedAction(path, updatePartNumberValue),
    changeResolutionValue: createNamedAction(path, changeResolutionValue),
    updateResolutionValue: createNamedAction(path, updateResolutionValue),
    changeSizeValue: createNamedAction(path, changeSizeValue),
    updateSizeValue: createNamedAction(path, updateSizeValue),
    changeVendorValue: createNamedAction(path, changeVendorValue),
    updateVendorValue: createNamedAction(path, updateVendorValue),
    addPanel: createNamedAction(path, addPanel),
    removePanel: createNamedAction(path, removePanel),
    changeValueSuccess: createNamedAction(path, changeValueSuccess)
  }
}

export {
  getActions
}
